/* eslint-disable no-nested-ternary */
import { useMemo } from 'react'
import { IInstitutionMediaListItem } from '@ucheba/store/institutions/item/types'

import { checkWebpSupport } from '@ucheba/utils/helpers/styles/mixins'

type TThumbSize = 'fullUrl' | 'thumbBig' | 'thumbMid' | 'thumbMin'

const imageType = checkWebpSupport() ? 'webp' : 'fallbackUrl'

export const useMediaList = (
  mediaList: IInstitutionMediaListItem[],
  thumbSize: TThumbSize = 'thumbMid'
): any => {
  const sortedList = [...mediaList].sort(
    (a, b) => Number(b.isOfficialPromo) - Number(!!a.isOfficialPromo)
  )

  const mediaLength = mediaList.length

  const listWithThumb = sortedList.map(
    ({ image, description, mediaType, fileUrl }, index) => {
      const src = mediaType.value === 1 ? image?.thumbBig[imageType] : fileUrl

      const thumb = image
        ? index === 0
          ? image.fullUrl
          : image[thumbSize]
        : `/static/img/video-covers/default__cover.png`

      return {
        src,
        thumb,
        subHtml: description,
        mediaType: mediaType?.value,
      }
    }
  )

  let gridTemplateAreas = ``
  let isShowMore = false

  if (mediaLength === 2) {
    gridTemplateAreas = `'A1 A1 A2'`
  } else if (mediaLength === 3) {
    gridTemplateAreas = `'A1 A2 A3'`
  } else if (mediaLength === 4) {
    gridTemplateAreas = `'A1 A1 A1 A2 A2 A3' 'A1 A1 A1 A2 A2 A4'`
  } else if (mediaLength === 5) {
    gridTemplateAreas = `'A1 A1 A1 A1 A2 A3' 'A1 A1 A1 A1 A4 A5'`
  } else if (mediaLength > 5) {
    gridTemplateAreas = `'A1 A1 A1 A1 A2 A3' 'A1 A1 A1 A1 A4 A5'`
    isShowMore = true
  }
  const result = useMemo(
    () => ({ list: listWithThumb, gridTemplateAreas, isShowMore }),
    [gridTemplateAreas, isShowMore, listWithThumb]
  )

  return result
}
